import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner'

import FirmwareItem from './FirmwareItem';
import Pagination from '../Common/Pagination';
import { firmwareMngService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';

class FirmwareMng extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalCount: 1,      // 전체 게시물수
            currentPage: 1,     // 현재 페이지
            totalPage: 1,       // 전체 페이지수 totalCount/pageCount
            start: 1,           // 화면에 보이는 첫번째 게시물
            listCount: 10,      // 한화면에 보여줄 게시물수

            pubType: "now",     // now(즉시배포=개별배포)/derv(예약배포=전체배포)
            firmwareList: "",
            isMobile: false,
            pubStatus: false,
        }

        this.setFirmwareList();
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }
    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    stateRefresh = () => {

        this.setState({
            currentPage: 1,
            listCount: 10,
        }, () => { this.setFirmwareList(); })
    };

    setFirmwareList = async () => {
        let formData = new FormData();
        formData.append('currentPage', this.state.currentPage);
        formData.append('listCount', this.state.listCount);
        formData.append('pubType', this.state.pubType);
        firmwareMngService.firmwareList(formData)
            .then(response => {
                if (response.status === 200 && response.data) {
                    console.log(response.data);
                    this.setState({
                        totalCount: response.data.totalCount,
                        currentPage: response.data.currentPage,
                        totalPage: response.data.totalPage,
                        start: response.data.start,
                        listCount: response.data.listCount,
                        firmwareList: response.data.firmwareList,
                    });
                }

            })
            .catch(this.handleErrors);
    };

    handlePubButton = (firmwareID, pubYN) => {
        const { myInfo } = this.props;
        this.state.firmwareList.map(firmware => {
            if (firmware.firmwareID === firmwareID) firmware.pubYN = pubYN;
            return firmware;
        });

        if (pubYN === "Y") {
            this.setState({
                pubStatus: true
            });

            let formData = new FormData();
            formData.append("firmwareID", firmwareID);
            formData.append('pubReg', "user");
            formData.append('pubUser', myInfo.userID);

            opbcdtService.publishPatch(formData)
                .then(response => {
                    console.log("배포 완료");
                    console.log(response);
                    this.props.successAlerts("배포가 완료되었습니다.");
                    this.setState({
                        pubStatus: false
                    });
                })
                .catch(error => {
                    this.handleErrors(error);
                    this.props.errorAlerts("배포 서버 오류 발생! 잠시 후 다시 이용해주세요.");
                    this.setState({
                        pubStatus: false
                    });
                });
        }
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleListCount = (e) => {
        this.setState({
            currentPage: 1,
            listCount: e.target.value
        }, () => { this.setFirmwareList(); });
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            currentPage: currentPage
        }, () => { this.setFirmwareList(); });
    };


    render() {
        const { firmwareList, listCount, totalCount, start, isMobile, pubStatus } = this.state;

        const colgroupList = ["10%", "10%", "10%", "10%", "40%", "20%"];
        const cellList = ["NO", "배포범위", "배포지역", "버전", "제목", "관리설정"];
        const listCounts = ["10", "20", "50"];

        return (
            <React.Fragment>
                <h2 className="s-page-tit">즉시 패치 관리</h2>
                <div className="search-result-wrapper firmware-mng s-normal-box">
                    <div className="row search-result-top">
                        <div className="col col-sm-6 col-md-5 col-lg-4 col-12 contents-search-result">
                            <i>검색결과: {totalCount}</i>
                            <i><button className="button w98-button white-button" style={{ width: isMobile ? '75px' : '98px' }} name="초기화" onClick={this.stateRefresh}><img src="/assets/images/ic-refresh.svg" alt="초기화" className="ic-refresh" />초기화</button></i>
                            <i>
                                <Link to="/firmwareAdd">
                                    <button className="button w98-button white-button" style={{ width: isMobile ? '86px' : '98px' }} name="신규등록"><img src="/assets/images/ic-register.svg" alt="" className="ic-register" />신규등록</button>
                                </Link>
                            </i>
                        </div>
                        <div className="col col-sm-2 col-md-2 col-lg-4 col-12">&nbsp;</div>
                        <div className="col col-sm-4 col-md-5 col-lg-4 col-12 contents-search-count">
                            <select className="input-box padding-l10" name="listCount" value={listCount} onChange={this.handleListCount}>
                                {listCounts.map((count, i) => {
                                    return <option key={i} value={count}>{count}건</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <table className="firmware-table" style={{ width: isMobile ? '1000px' : '100%' }}>
                            <colgroup>
                                {colgroupList.map((col, index) => {
                                    return <col key={index} width={col} />;
                                })}
                            </colgroup>
                            <thead className="table-head">
                                <tr>
                                    {cellList.map((cell, i) => {
                                        return <th className="table-head-cell" key={i}>{cell}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {pubStatus &&
                                    <tr>
                                        <td colSpan={cellList.length}>
                                            <div className="text-align-center">
                                                <Loader
                                                    type="Rings"
                                                    color="#00BFFF"
                                                    height={'50%'}
                                                    width={'50%'}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {!pubStatus && firmwareList && firmwareList.length > 0
                                    ?
                                    firmwareList.map((firmware, i) => {
                                        return <FirmwareItem key={i} no={totalCount - (start + i) + 1} firmware={firmware} handlePubButton={this.handlePubButton} />;
                                    })
                                    :
                                    <tr>
                                        <td className="text-align-center" colSpan={cellList.length}>
                                            <div className="" style={{ margin: '20px auto' }}>
                                                <img src={"/assets/images/ic-no-data.svg"} alt="데이터없음" />
                                                <br />
                                                데이터가 없습니다.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination list={this.state} getCurrentPage={this.getCurrentPage} />
            </React.Fragment>
        );
    }
}

function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(FirmwareMng);